import React from 'react';
import { Badge, Button, Space, Tag, Typography } from 'antd';
import {
  TagOutlined,
  EyeOutlined,
  ShoppingCartOutlined,
  ClockCircleOutlined,
  ShoppingOutlined,
  UserAddOutlined,
  FundOutlined,
} from '@ant-design/icons';
import { formatNumber } from '../../../../../core/utils/campaigns';
import { formatWholeNumberNaN } from '../../../../../core/utils/campaigns';
import moment from 'moment';
import { dateFormat } from '../../../Tasks/configs/designTokens';

const { Text } = Typography;

const TagMobileCard = ({ record, type, onClick, onTestSignal, isAttentionSignals, onViewCampaigns }) => {
  const renderEvents = () => {
    if (type === 'measurement') {
      const { transactions, pageViews, signups, date, colors, typeColors, isSignUps, sessions } =
        record.measuredEvents;

      return (
        <>
          <div className="tags-mobile-card__events">
            {pageViews !== undefined && (
              <Tag color={colors.pageViews}>
                <Text type={typeColors.pageViews}>
                  <EyeOutlined className="tags-table-metric__label-icon" />
                  <span className="tags-table-metric__label-text">Page Views </span>
                </Text>
                <Text type={typeColors.pageViews} strong>
                  {formatWholeNumberNaN(pageViews)}
                </Text>
              </Tag>
            )}
            {transactions !== undefined && (
              <Tag color={colors.transactions}>
                <Text type={typeColors.transactions}>
                  <ShoppingCartOutlined className="tags-table-metric__label-icon" />
                  <span className="tags-table-metric__label-text">Transactions </span>
                </Text>
                <Text type={typeColors.transactions} strong>
                  {formatWholeNumberNaN(transactions)}
                </Text>
              </Tag>
            )}
            {(isSignUps || signups > 0) && (
              <Tag color={colors.signups}>
                <Text type={typeColors.signups}>
                  <UserAddOutlined className="tags-table-metric__label-icon" />
                  <span className="tags-table-metric__label-text">Sign-Ups </span>
                </Text>
                <Text type={typeColors.signups} strong>
                  {formatWholeNumberNaN(signups)}
                </Text>
              </Tag>
            )}
            {(sessions || sessions > 0) && (
              <Tag color={colors.sessions}>
                <Text type={typeColors.sessions}>
                  <ClockCircleOutlined className="tags-table-metric__label-icon" />
                  <span className="tags-table-metric__label-text">Sessions </span>
                </Text>
                <Text type={typeColors.sessions} strong>
                  {formatWholeNumberNaN(sessions)}
                </Text>
              </Tag>
            )}
          </div>
          {date && (
            <Text type="secondary" className="tags-mobile-card__date">
              {moment(date).format(dateFormat.full)}
            </Text>
          )}
        </>
      );
    }

    if (type === 'publisher') {
      return (
        <>
          <div className="tags-mobile-card__events">
            <Tag color={record.color}>
              <Text type={record.typeColor}>
                <EyeOutlined className="tags-table-metric__label-icon" />
                <span className="tags-table-metric__label-text">Page Views </span>
              </Text>
              <Text type={record.typeColor} strong>
                {formatNumber(record.pageViews)}
              </Text>
            </Tag>
          </div>
          {record.date && (
            <Text type="secondary" className="tags-mobile-card__date">
              {record.date}
            </Text>
          )}
        </>
      );
    }

    if (type === 'impression') {
      return (
        <>
          <div className="tags-mobile-card__events">
            <Tag color={record.color}>
              <Text type={record.typeColor}>
                <FundOutlined className="tags-table-metric__label-icon" />
                <span className="tags-table-metric__label-text">Impressions </span>
              </Text>
              <Text type={record.typeColor} strong>
                {formatNumber(record.impressions)}
              </Text>
            </Tag>
          </div>
          {record.date && (
            <Text type="secondary" className="tags-mobile-card__date">
              {record.date}
            </Text>
          )}
        </>
      );
    }

    return null;
  };

  const tagId = type === 'measurement' ? record.appId : record.tagId;
  const subtitle =
    type === 'measurement'
      ? record.advertiser
      : type === 'publisher'
      ? record.domain
      : record.dsp;
  const subtitleLabel =
    type === 'measurement'
      ? 'Advertiser'
      : type === 'publisher'
      ? 'Domain'
      : 'Platform';

  return (
    <div className="tags-mobile-card" onClick={onClick}>
      <div className="tags-mobile-card__header">
        <div className="tags-mobile-card__title-group">
          <Text className="tags-mobile-card__name">{record.name}</Text>
          {subtitle && (
            <Text type="secondary" className="tags-mobile-card__subtitle">
              {subtitleLabel}: {subtitle}
            </Text>
          )}
        </div>
        <Button
          color="primary"
          variant="filled"
          size="small"
          icon={<TagOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            onTestSignal(record);
          }}
        >
          Test
        </Button>
      </div>

      {renderEvents()}

      {type === 'measurement' && (
        <div className="tags-mobile-card__actions">
          {isAttentionSignals && (
            <div className="tags-mobile-card__funnels">
              <Text type="secondary" className="tags-mobile-card__action-label">Funnels</Text>
              <Badge
                count={record.funnels}
                className={record.funnels > 0 ? 'tags-main__funnels-badge--active' : 'tags-main__funnels-badge--inactive'}
                showZero
              />
            </div>
          )}
          {record.appId && onViewCampaigns && (
            <Button
              type="default"
              size="small"
              icon={<EyeOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                onViewCampaigns();
              }}
              className="tags-mobile-card__campaigns-btn"
            >
              Campaigns
            </Button>
          )}
        </div>
      )}

      <div className="tags-mobile-card__footer">
        <Typography.Paragraph
          copyable
          className="tags-mobile-card__tag-id"
          onClick={(e) => e.stopPropagation()}
        >
          {tagId}
        </Typography.Paragraph>
      </div>
    </div>
  );
};

export default TagMobileCard;
